import { render, staticRenderFns } from "./attention.vue?vue&type=template&id=f8e0f272&scoped=true"
import script from "./attention.vue?vue&type=script&lang=js"
export * from "./attention.vue?vue&type=script&lang=js"
import style0 from "./attention.vue?vue&type=style&index=0&id=f8e0f272&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e0f272",
  null
  
)

export default component.exports